import { X, CheckCircle } from 'lucide-react'

interface PasswordSuccessModalProps {
  isOpen: boolean
  onClose: () => void
}

export const PasswordSuccessModal = ({ isOpen, onClose }: PasswordSuccessModalProps) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-8">
        {/* Close Button */}
        <div className="flex justify-end mb-4">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Success Icon */}
        <div className="flex flex-col items-center text-center">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" strokeWidth={2} />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Password Changed
          </h2>

          {/* Description */}
          <p className="text-sm text-gray-500 mb-8 max-w-sm">
            Choose the right level of protection for your business. Every plan is designed to scale with your growth.
          </p>

          {/* Back Button */}
          <button
            onClick={onClose}
            className="w-full bg-gray-900 text-white py-4 rounded-full font-medium hover:bg-gray-800 transition-colors"
          >
            Back to Settings
          </button>
        </div>
      </div>
    </div>
  )
}
